export default "__VITE_ASSET__a04279d5__"